import { useEffect, useCallback } from 'react'
import { AuthField } from './auth-field'
import { AuthFieldType } from './auth-field-type'

interface AccountFieldManagerProps {
  newConnection: boolean
  updatedAccount: any
  setRequiredFieldsMissing: (fieldsMissing: boolean) => void
  setUpdatedAccount: (updatedAccount: any) => void
  accountFields: AuthFieldType[]
}

export const AccountFieldManager = ({
  newConnection,
  updatedAccount,
  setRequiredFieldsMissing,
  setUpdatedAccount,
  accountFields,
}: AccountFieldManagerProps) => {
  function checkIfRequiredFieldsHaveValues(): boolean {
    let invalidFields = false
    accountFields.forEach(field => {
      if (field.isOptional) {
        return
      }

      if (
        !updatedAccount.metadata[field.fieldKey] ||
        updatedAccount.metadata[field.fieldKey].trim() === '' ||
        field.hasError
      ) {
        invalidFields = true
      }
    })
    return invalidFields
  }

  const requiredFieldsHaveValue = checkIfRequiredFieldsHaveValues()

  const checkForAccountFieldErrors = validRequiredFields => {
    setRequiredFieldsMissing(validRequiredFields)
  }

  useEffect(() => {
    checkForAccountFieldErrors(requiredFieldsHaveValue)
  }, [requiredFieldsHaveValue])

  const handleAccountMetadataChange = useCallback(
    (value, name) => {
      if (value.trim() === '') {
        const { metadata, ...newAccount } = updatedAccount
        const { [name]: _, ...rest } = metadata
        newAccount.metadata = rest
        setUpdatedAccount(newAccount)
        return
      }
      setUpdatedAccount(prevState => ({
        ...prevState,
        metadata: {
          ...prevState.metadata,
          [name]: value,
        },
      }))
    },
    [newConnection, updatedAccount.metadata],
  )

  return (
    <>
      {accountFields.map(authField => (
        <AuthField
          key={authField.fieldLabel}
          authField={authField}
          newConnection={newConnection}
          onFieldChange={handleAccountMetadataChange}
        />
      ))}
    </>
  )
}
